import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-wbs-allocation-methods',
  templateUrl: './wbs-allocation-methods.component.html',
  styleUrls: ['./wbs-allocation-methods.component.css']
})
export class WbsAllocationMethodsComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.WBSAllocationMethods.columns;
    this.data = this.report.WBSAllocationMethods.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.WBSAllocationMethods.data;
    const gridInstance = this.gridContext.getInstance('WBSAllocationMethods');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/wbs-allocation-methods/wbs-allocation-methods.component.ts